import { Card, CardTitle, Divider, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const TransactionDetailPageSkeleton = () => {
  return (
    <Styles.Container>
      <Styles.Header>
        <Styles.NavRow>
          <Skeleton variant="rounded" width={140} height={20} />
          <Styles.NavContainer>
            <Skeleton variant="rounded" width={70} height={20} />
            <Skeleton variant="rounded" width={50} height={20} />
          </Styles.NavContainer>
        </Styles.NavRow>
        <Styles.HeaderOptions>
          <Styles.HeaderOptionsLeft>
            <Skeleton variant="text" width={70} height={28} />
            <Skeleton variant="text" width={120} height={20} />
            <Skeleton variant="rounded" width={80} height={24} />
            <Skeleton variant="rounded" width={100} height={24} />
          </Styles.HeaderOptionsLeft>
          <Styles.AcceptOrRejectContainer>
            <Skeleton variant="rounded" width={90} height={24} />
            <Skeleton variant="rounded" width={90} height={24} />
            <Skeleton variant="rounded" width={120} height={24} />
          </Styles.AcceptOrRejectContainer>
        </Styles.HeaderOptions>
      </Styles.Header>

      <Styles.MainContainer>
        <Styles.SectionContainer>
          <Card showBorder={false}>
            <CardTitle>
              <Skeleton variant="text" width={140} height={24} />
            </CardTitle>
            <Styles.ItemsContainer>
              <Styles.LineItem>
                <Styles.LineItemBody>
                  <Skeleton variant="rounded" width={100} height={20} />
                  <Skeleton variant="text" width={80} height={14} />
                  <Styles.ProductRow>
                    <Skeleton variant="rounded" width={88} height={88} />
                    <Styles.ProductInfo>
                      <Skeleton variant="text" width={140} height={20} />
                      <Skeleton variant="text" width={100} height={14} />
                      <Skeleton variant="text" width={70} height={20} />
                    </Styles.ProductInfo>
                  </Styles.ProductRow>
                </Styles.LineItemBody>
                <Styles.ReasonBanner>
                  <Skeleton variant="rounded" width={120} height={16} />
                  <Skeleton variant="rounded" width={220} height={14} />
                </Styles.ReasonBanner>
              </Styles.LineItem>
            </Styles.ItemsContainer>
            <Skeleton variant="rounded" width="100%" height={48} />
          </Card>

          <Card showBorder={false}>
            <CardTitle>
              <Skeleton variant="text" width={160} height={24} />
            </CardTitle>
            <Styles.SummaryCardContent>
              <Styles.SummaryContainer>
                <Skeleton variant="rounded" width="100%" height={56} />
                <Skeleton variant="rounded" width="50%" height={16} />
                <Skeleton variant="rounded" width="55%" height={16} />
              </Styles.SummaryContainer>
              <Skeleton variant="rounded" width="100%" height={48} />
              <Skeleton variant="rounded" width="100%" height={48} />
            </Styles.SummaryCardContent>
          </Card>

          <Card showBorder={false}>
            <CardTitle>
              <Skeleton variant="text" width={100} height={24} />
            </CardTitle>
            <Styles.TimelineContent>
              <Styles.CommentRow>
                <Skeleton variant="circular" width={32} height={32} />
                <Styles.CommentInput>
                  <Skeleton variant="rounded" width="100%" height={32} />
                </Styles.CommentInput>
                <Skeleton variant="circular" width={24} height={24} />
              </Styles.CommentRow>
              <Skeleton variant="rounded" width="100%" height={40} />
              <Divider />
              <Skeleton variant="text" width={60} height={14} />
              <Styles.TimelineEvents>
                <Styles.TimelineEvent>
                  <Skeleton variant="circular" width={20} height={20} />
                  <Styles.TimelineEventText>
                    <Skeleton variant="text" width={180} height={16} />
                    <Skeleton variant="text" width={80} height={12} />
                  </Styles.TimelineEventText>
                </Styles.TimelineEvent>
                <Styles.TimelineEvent>
                  <Skeleton variant="circular" width={20} height={20} />
                  <Styles.TimelineEventText>
                    <Skeleton variant="text" width={150} height={16} />
                    <Skeleton variant="text" width={80} height={12} />
                  </Styles.TimelineEventText>
                </Styles.TimelineEvent>
              </Styles.TimelineEvents>
            </Styles.TimelineContent>
          </Card>
        </Styles.SectionContainer>

        <Styles.SectionContainer>
          <Card showBorder={false}>
            <CardTitle>
              <Skeleton variant="text" width={120} height={24} />
              <Skeleton variant="circular" width={24} height={24} />
            </CardTitle>
            <Styles.DetailCardContent>
              <Styles.InfoContainer>
                <Skeleton variant="rounded" width="100%" height={40} />
                <Styles.ChipsRow>
                  <Skeleton variant="rounded" width={90} height={24} />
                  <Skeleton variant="rounded" width={110} height={24} />
                </Styles.ChipsRow>
                <Styles.DatesRow>
                  <Skeleton variant="rounded" width={100} height={16} />
                  <Skeleton variant="rounded" width={120} height={14} />
                </Styles.DatesRow>
              </Styles.InfoContainer>
              <Divider />
              <Styles.SummaryContainer>
                <Skeleton variant="rounded" width="100%" height={56} />
                <Skeleton variant="rounded" width="50%" height={16} />
                <Skeleton variant="rounded" width="55%" height={16} />
              </Styles.SummaryContainer>
              <Skeleton variant="rounded" width="100%" height={48} />
            </Styles.DetailCardContent>
          </Card>

          <Card showBorder={false}>
            <CardTitle>
              <Skeleton variant="text" width={140} height={24} />
              <Skeleton variant="circular" width={24} height={24} />
            </CardTitle>
            <Styles.InfoBlocks>
              <Styles.Info>
                <Skeleton variant="text" width={100} height={14} />
                <Skeleton variant="rounded" width={120} height={20} />
              </Styles.Info>
              <Styles.Info>
                <Skeleton variant="text" width={50} height={14} />
                <Skeleton variant="rounded" width={200} height={20} />
              </Styles.Info>
              <Styles.Info>
                <Skeleton variant="text" width={50} height={14} />
                <Skeleton variant="rounded" width={140} height={20} />
              </Styles.Info>
              <Skeleton variant="text" width={140} height={20} />
            </Styles.InfoBlocks>
          </Card>

          <Card showBorder={false}>
            <CardTitle>
              <Skeleton variant="text" width={130} height={24} />
            </CardTitle>
            <Styles.InfoBlocks>
              <Styles.Info>
                <Skeleton variant="text" width={120} height={14} />
                <Skeleton variant="rounded" width={80} height={20} />
              </Styles.Info>
              <Styles.Info>
                <Skeleton variant="text" width={100} height={14} />
                <Skeleton variant="rounded" width={120} height={20} />
              </Styles.Info>
              <Styles.Info>
                <Skeleton variant="text" width={100} height={14} />
                <Skeleton variant="rounded" width={100} height={20} />
              </Styles.Info>
              <Styles.Info>
                <Skeleton variant="text" width={50} height={14} />
                <Skeleton variant="rounded" width={200} height={20} />
              </Styles.Info>
              <Styles.Info>
                <Skeleton variant="text" width={50} height={14} />
                <Skeleton variant="rounded" width={140} height={20} />
              </Styles.Info>
            </Styles.InfoBlocks>
          </Card>

          <Card showBorder={false}>
            <CardTitle>
              <Skeleton variant="text" width={130} height={24} />
              <Skeleton variant="circular" width={24} height={24} />
            </CardTitle>
            <Styles.InfoBlocks>
              <Styles.Info>
                <Skeleton variant="text" width={100} height={14} />
                <Skeleton variant="rounded" width={80} height={20} />
              </Styles.Info>
              <Styles.Info>
                <Skeleton variant="text" width={120} height={14} />
                <Skeleton variant="rounded" width={140} height={20} />
              </Styles.Info>
              <Styles.Info>
                <Skeleton variant="text" width={60} height={14} />
                <Skeleton variant="rounded" width={120} height={20} />
              </Styles.Info>
              <Styles.Info>
                <Skeleton variant="text" width={100} height={14} />
                <Skeleton variant="rounded" width={90} height={20} />
                <Skeleton variant="rounded" width={70} height={20} />
                <Skeleton variant="rounded" width={30} height={20} />
                <Skeleton variant="rounded" width={150} height={20} />
                <Skeleton variant="rounded" width={50} height={20} />
              </Styles.Info>
            </Styles.InfoBlocks>
          </Card>

          <Card showBorder={false}>
            <CardTitle>
              <Skeleton variant="text" width={100} height={24} />
            </CardTitle>
            <Styles.Info>
              <Skeleton variant="text" width={70} height={14} />
              <Styles.FileRow>
                <Skeleton variant="circular" width={20} height={20} />
                <Skeleton variant="rounded" width={220} height={20} />
                <Skeleton variant="circular" width={20} height={20} />
              </Styles.FileRow>
            </Styles.Info>
          </Card>
        </Styles.SectionContainer>
      </Styles.MainContainer>
    </Styles.Container>
  )
}

export default TransactionDetailPageSkeleton
